<template>
  <div id="parentx">
    <div
      class="containerIconSidenav"
      :class="[active ? isSidenavOpen : isSidenavClose]"
      @click="changeStateSideNav"
    >
      <i class="geodir-icon-menus"></i>
    </div>

    <vs-sidebar
      parent="body"
      :hidden-background="true"
      :click-not-close="true"
      default-index="1"
      color="primary"
      class="sidebarGeodirMap"
      spacer
      v-model="active"
    >
      <div class="header-sidebar" slot="header">
        <div class="text-geodir">Geodir Maps</div>

        <a class="closebtn" @click="changeStateSideNav">
          <p class="geodir-icon-double-arrow"></p>
        </a>
      </div>

      <!--<div v-if="!isListOptionOpen">
          <el-row :gutter="20">    
            <el-col :span="7">
              <el-button style="margin-bottom: 10px;" icon="el-icon-back" size="mini"  round @click="openPanelOptions()">Volver</el-button>
            </el-col>
          </el-row>
        </div>-->

      <el-row v-if="optionSelected == 'searchDirectionStructured'">
        <el-col :span="17">
          <div class="menu-title-direction">Buscar domicilio:</div>
        </el-col>
        <el-col :span="7">
          <el-button
            icon="el-icon-back"
            size="mini"
            round
            @click="openPanelOptions()"
            >Volver</el-button
          >
        </el-col>
        <el-col :span="24">
          <SearchDirection></SearchDirection>
        </el-col>
      </el-row>

      <el-row v-if="isLoggedUser && optionSelected == 'systemBuilder'">
        <el-col :span="17">
          <div class="menu-title-builder">Geodir builder:</div>
        </el-col>
        <el-col :span="7">
          <el-button
            icon="el-icon-back"
            size="mini"
            round
            @click="openPanelOptions()"
            >Volver</el-button
          >
        </el-col>
        <el-col :span="24">
          <BuilderOption :map="map"></BuilderOption>
        </el-col>
      </el-row>

      <vs-row v-if="isListOptionOpen">
        <vs-col vs-type="flex" vs-align="center" vs-w="12" class="row-option">
          <i class="uil uil-map-marker icon-options"></i>
          <vs-button
            class="btn-option"
            line-origin="left"
            type="flat"
            size="small"
            color="#3E6BF2"
            @click="openOption('searchDirectionStructured')"
            >Buscar domicilio</vs-button
          >
        </vs-col>
      </vs-row>

      <vs-row v-if="isListOptionOpen && isLoggedUser && !userIsBasic">
        <vs-col vs-type="flex" vs-align="center" vs-w="12" class="row-option">
          <i class="uil uil-layer-group icon-options"></i>
          <vs-button
            class="btn-option"
            line-origin="left"
            type="flat"
            size="small"
            color="#3E6BF2"
            @click="openOption('systemBuilder')"
            >Geodir builder</vs-button
          >
        </vs-col>
      </vs-row>

      <vs-row v-if="isListOptionOpen">
        <vs-col vs-type="flex" vs-align="center" vs-w="12" class="row-option">
          <i class="uil uil-image-share icon-options"></i>
          <share></share>
        </vs-col>
      </vs-row>

      <vs-row v-if="isListOptionOpen">
        <vs-col vs-type="flex" vs-align="center" vs-w="12" class="row-option">
          <i class="uil uil-question-circle icon-options"></i>
          <vs-button
            class="btn-option"
            line-origin="left"
            type="flat"
            size="small"
            color="#3E6BF2"
            @click="openHelp"
            >Ayuda</vs-button
          >
        </vs-col>
      </vs-row>

      <div class="footer-sidebar" slot="footer"></div>
    </vs-sidebar>
  </div>
</template>

<script>
import SearchDirection from "../searchStructured/SearchDirection";

//import BuilderOption from './builder/BuilderOptions'

import BuilderOption from "../builder/GeodirBuilder";
import Share from "../Share";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    SearchDirection,
    BuilderOption,
    Share,
  },
  data: () => ({
    isSidenavOpen: "btnOpenSideNav",
    isSidenavClose: "btnOpenSideNavClosed",
    //direction
    optionSelected: "",
    isLoggedUser: false,
    active: false,
    activeOption: ["1"],
    isListOptionOpen: true,
    //user: {},
    userIsBasic: true,
  }),
  created() {
    if (this.checkLogin()) {
      this.isLoggedUser = true;
    }
  },
  mounted() {
    let app = this;
    this.$store.watch(this.$store.getters.isOpenSidenav, (openSidenav) => {
      app.active = openSidenav;
    });

    /*this.user = this.$store.getters.userData;
    console.log("SIDENAV USER");
    console.log(this.user);
    this.userIsAdmin = this.user.roles.includes("ROLE_ADMIN");
    console.log(this.userIsAdmin);*/
  },
  computed: {
    ...mapState(["map", "user"]),
  },
  watch: {
    user(newValue, oldValue) {
      console.log("WATCH USER");
      this.userIsBasic = newValue.roles.includes("ROLE_USER");
      console.log(this.userIsAdmin);
    },
  },
  methods: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    changeStateSideNav() {
      this.active = !this.active;
      this.$store.commit("SET_SIDENAV", this.active);
    },
    handleChangeOptionCollapse(val) {
      console.log(val);
    },
    openOption(option) {
      this.optionSelected = option;
      this.isListOptionOpen = false;
    },
    openPanelOptions() {
      this.isListOptionOpen = true;
      this.optionSelected = "";
    },
    openHelp() {
      window.open("http://www.geodir.co/documentacion/maps.html", "_blank");
    },
  },
};
</script>


<style lang="stylus">
.menu-title-direction {
  margin: 0px 10px;
}

.menu-title-builder {
  margin: 0px 14px;
}

.containerIconSidenav {
  text-align: center !important;
  cursor: pointer;
  height: 48px;
  width: 48px;
  padding: 13px 0;
  background: white;
  top: 10px;
  position: fixed;
  z-index: 1000;
  transition: 0.22s;
  text-align: left;
  display: inline-block;
}

.btnOpenSideNavClosed {
  left: 10px;
}

.btnOpenSideNav {
  left: 330px;
}

.sidebarGeodirMap span:before {
  position: absolute;
  cursor: pointer;
}

.vs-sidebar--items {
  height: 100% !important;
}

/* fill .uil-times {
  margin-bottom: -28px;
	padding: 0px 18px;
	font-size: 20px;
  color: #a8a9ad;
  float: right;
} */
.btn-option {
  font-size: 14px !important;
  width: 100% !important;
  text-align: left;
  color: #777777 !important;
}

.icon-options {
  color: #3E6BF2;
}

.row-option {
  margin: 5px 20px !important;
}

.vs-sidebar {
  max-width: 320px !important;
}

.header-sidebar {
  margin: 0px 20px;
  color: #2164f9;
  font-size: 20px;
}

.closebtn {
  position: absolute;
  margin: -25px 0px 0px 252px;
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
</style>